import { apiClient } from "../API/axiosInstance";
import { logger } from "../utils/logger";

/**
 * Service class for geofence operations
 */
export class GeofenceService {
  static async fetchGeofences(orgID) {
    if (orgID === undefined || orgID === 0) return [];
    const result = await apiClient.get(`/geofence/organisation/${orgID}`);
    return result.data || [];
  }

  static async fetchGeofence(geofenceId) {
    const result = await apiClient.get(`/geofence/${geofenceId}`);
    return result.data;
  }

  static async createGeofence(geofenceData) {
    const response = await apiClient.post("/geofence", geofenceData);
    return response;
  }

  static async updateGeofence(geofenceId, geofenceData) {
    const response = await apiClient.put(
      `/geofence/${geofenceId}`,
      geofenceData
    );
    return response;
  }

  static async deleteGeofence(geofenceId) {
    // Safety check: if somehow an object is passed, log error
    if (typeof geofenceId === "object") {
      logger.error(
        "[GeofenceService] deleteGeofence received object instead of ID",
        {
          geofenceId,
        }
      );
      throw new Error(
        "Invalid geofenceId: expected number or string, got object"
      );
    }

    const response = await apiClient.delete(`/geofence/${geofenceId}`);

    return response;
  }

  static async updateGeofenceStatus(geofenceId, status) {
    const word = status === "active" ? "activate" : "deactivate";
    const response = await apiClient.put(`/geofence/${geofenceId}/${word}`);
    return response;
  }

  static async fetchGeofenceContacts(geofenceId) {
    const response = await apiClient.get(`/geofence/${geofenceId}/contacts`);
    return response.data;
  }

  static getGeofenceTitle(tableMeta) {
    if (!tableMeta) return;
    if (!tableMeta.rowData) return;

    let geofence_action = tableMeta.rowData[16];
    let command = tableMeta.rowData[17];

    let title = "";
    title = `Send Downlink on Geofence ${geofence_action} ${command}`;
    return title;
  }
}
